import { Component, Input, OnInit } from '@angular/core';

import { CandidatoAgendamentoModel } from '@core/models/agendamento/candidato-agendamento.model';
import { SituacaoCandidatoDetranModel } from '@core/models/gestao/situacao-candidato-detran.model';
import { SituacaoCandidatoDetranService } from '@core/services/apis/gestao/situacao-candidato-detran.service';

@Component({
  selector: 'app-tab-stage-candidate',
  templateUrl: './tab-stage-candidate.component.html',
  styleUrls: ['./tab-stage-candidate.component.scss']
})
export class TabStageCandidateComponent implements OnInit {
  @Input() candidatoCpf: string;
  candidateStage: SituacaoCandidatoDetranModel;
  agendamentos: CandidatoAgendamentoModel[] = [];
  dataExameTeorico: string;
  dataAgendamentoExameTeorico: string;
  dataExamePratico2rodas: string;
  dataAgendamentoExamePratico2rodas: string;
  dataExamePratico4rodas: string;
  dataAgendamentoExamePratico4rodas: string;

  constructor(
    private _situacaoCandidatoService: SituacaoCandidatoDetranService,
  ) { }

  ngOnInit(): void {
    this._getStageCandidate();
  }

  private _getStageCandidate(): void {
    this._situacaoCandidatoService
      .getSituationByCpf(this.candidatoCpf)
      .subscribe((res) => {
        this.candidateStage = res;
        this.dataExameTeorico = this.candidateStage?.items?.[0]?.etapas?.find((e) => e.codigo === 12)?.data;
        this.dataAgendamentoExameTeorico = this.candidateStage?.items?.[0]?.etapas?.find((e) => e.codigo === 11)?.data;
        this.dataExamePratico2rodas = this.candidateStage?.items?.[0]?.etapas?.find((e) => e.codigo === 14)?.data;
        this.dataAgendamentoExamePratico2rodas = this.candidateStage?.items?.[0]?.etapas?.find((e) => e.codigo === 13)?.data;
        this.dataExamePratico4rodas = this.candidateStage?.items?.[0]?.etapas?.find((e) => e.codigo === 16)?.data;
        this.dataAgendamentoExamePratico4rodas = this.candidateStage?.items?.[0]?.etapas?.find((e) => e.codigo === 15)?.data;
        const etapas = this.candidateStage?.items?.[0]?.etapas || [];
        const newEtapas = [...etapas];
        newEtapas.sort((a, b) => (a.codigo || 0) - (b.codigo || 0));

        const indexAgendamentoExameTeorico = newEtapas.findIndex((e) => e.codigo === 11);
        const indexAgendamentoExamePratico2rodas = newEtapas.findIndex((e) => e.codigo === 13);
        const indexAgendamentoExamePratico4rodas = newEtapas.findIndex((e) => e.codigo === 15);
        const indexExameTeorico = newEtapas.findIndex((e) => e.codigo === 12);
        const indexExame2Rodas = newEtapas.findIndex((e) => e.codigo === 14);
        const indexExame4Rodas = newEtapas.findIndex((e) => e.codigo === 16);

        if (indexAgendamentoExameTeorico !== -1) {
          newEtapas.splice(indexAgendamentoExameTeorico, 0, {
            codigo: null,
            numeroExame: null,
            nome: 'CURSO TEÓRICO',
            data: null,
            descricao: this.dataAgendamentoExameTeorico ? "REALIZADO" : "",
            concluida: this.dataAgendamentoExameTeorico ? true : false,
            faltas: null,
          });
        } else if (indexExameTeorico !== -1) {
          newEtapas.splice(indexExameTeorico, 0, {
            codigo: null,
            numeroExame: null,
            nome: 'CURSO TEÓRICO',
            data: null,
            descricao: this.dataExameTeorico ? "REALIZADO" : "",
            concluida: this.dataExameTeorico ? true : false,
            faltas: null,
          });
        }

        if (indexAgendamentoExamePratico2rodas !== -1) {
          newEtapas.splice(indexAgendamentoExamePratico2rodas + 1, 0, {
            codigo: null,
            numeroExame: null,
            nome: 'CURSO PRÁTICO 2 RODAS',
            data: null,
            descricao: this.dataAgendamentoExamePratico2rodas ? "REALIZADO" : "",
            concluida: this.dataAgendamentoExamePratico2rodas ? true : false,
            faltas: null,
          });
        } else if (indexExame2Rodas !== -1 && indexExameTeorico !== -1) {
          newEtapas.splice(indexExame2Rodas + 1, 0, {
            codigo: null,
            numeroExame: null,
            nome: 'CURSO PRÁTICO 2 RODAS',
            data: null,
            descricao: this.dataExamePratico2rodas ? "REALIZADO" : "",
            concluida: this.dataExamePratico2rodas ? true : false,
            faltas: null,
          });
        } else if (indexExame2Rodas !== -1) {
          newEtapas.splice(indexExame2Rodas, 0, {
            codigo: null,
            numeroExame: null,
            nome: 'CURSO PRÁTICO 2 RODAS',
            data: null,
            descricao: this.dataExamePratico2rodas ? "REALIZADO" : "",
            concluida: this.dataExamePratico2rodas ? true : false,
            faltas: null,
          });
        }

        if (indexAgendamentoExamePratico4rodas !== -1 && indexAgendamentoExamePratico2rodas !== -1) {
          newEtapas.splice(indexAgendamentoExamePratico4rodas + 2, 0, {
            codigo: null,
            numeroExame: null,
            nome: 'CURSO PRÁTICO 4 RODAS',
            data: null,
            descricao: this.dataAgendamentoExamePratico4rodas ? "REALIZADO" : "",
            concluida: this.dataAgendamentoExamePratico4rodas ? true : false,
            faltas: null,
          });
        } else if (indexAgendamentoExamePratico4rodas !== -1) {
          newEtapas.splice(indexAgendamentoExamePratico4rodas + 1, 0, {
            codigo: null,
            numeroExame: null,
            nome: 'CURSO PRÁTICO 4 RODAS',
            data: null,
            descricao: '',
            concluida: this.dataAgendamentoExamePratico4rodas ? true : false,
            faltas: null,
          });
        } else if (indexExame4Rodas !== -1 && indexExame2Rodas !== -1) {
          newEtapas.splice(indexExame4Rodas + 2, 0, {
            codigo: null,
            numeroExame: null,
            nome: 'CURSO PRÁTICO 4 RODAS',
            data: null,
            descricao: this.dataExamePratico4rodas ? "REALIZADO" : "",
            concluida: this.dataExamePratico4rodas ? true : false,
            faltas: null,
          });
        } else if (indexExame4Rodas !== -1) {
          newEtapas.splice(indexExame4Rodas + 1, 0, {
            codigo: null,
            numeroExame: null,
            nome: 'CURSO PRÁTICO 4 RODAS',
            data: null,
            descricao: this.dataExamePratico4rodas ? "REALIZADO" : "",
            concluida: this.dataExamePratico4rodas ? true : false,
            faltas: null,
          });
        }

        this.candidateStage.items[0].etapas = newEtapas;
      });
  }
}
